import api from './api'
import { cp, http } from './api'
import i18n from './i18n'

const APPLICATION_INIT = 0;
const APPLICATION_AUTH = 1;
const APPLICATION_MODULES = 2;
const APPLICATION_COMPLETE = 3;
const states = { APPLICATION_INIT, APPLICATION_AUTH, APPLICATION_MODULES, APPLICATION_COMPLETE };
export { cp, http, i18n, states }

export default class DataLayer {
  constructor() { }

  bootstrapClientProject({ store }) {
    return new Promise((resolve, reject) => {
      api.bootstrap()
        .then(response => {
          let data = response.data;

          // Make sure the user is authenticated
          // if (data.user === null) {
          //   api.authenticate();
          //   return reject();
          // }

          // Start the keep alive
          this.keepAlive();

          // Save the config in the store
          store.dispatch('bootstrap/config', data);

          return resolve(data);
        })
    })
  }

  bootstrapLocal({ store }) {
    return new Promise(resolve => {
      http.get('/statics/json/bootstrap.json')
        .then(response => {
          let data = response.data;

          // Save the config in the store
          store.dispatch('bootstrap/config', data);

          return resolve(data);
        })
    })
  }

  keepAlive() {
    setInterval(() => {
      api.keepAlive();
    }, 1000 * 60 * 5);
  }

  logout(){
    api.logout()
  }

  reset({ store }) {
    return new Promise((resolve, reject) => {
      api.reset()
      .then(response => {
          let data = response.data;
          // Save the config in the store
          store.dispatch('bootstrap/config', data);
          resolve(data);
        })
        .catch(error => {
          reject();
        });
    })
  }
}
